import { RateUwFailType, RateResponseType, RateType } from './types';

export const transformRateResponse = (
  rateResponse: RateResponseType
): RateType | RateUwFailType => rateResponse;
